// Centralized API URL helper
// Returns a full URL when `REACT_APP_API_URL` is set, otherwise returns a
// relative path so Create React App's dev proxy can forward requests.
export function api(path) {
  const base = process.env.REACT_APP_API_URL || "";

  if (base && base.length > 0) {
    const normalizedBase = base.replace(/\/$/, "");
    const normalizedPath = path.startsWith("/") ? path : `/${path}`;
    return `${normalizedBase}${normalizedPath}`;
  }

  // No base configured — return relative path for dev proxy or same-origin requests
  return path.startsWith("/") ? path : `/${path}`;
}

export default api;
